// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"4f413e51","276":"dbd59ef4","510":"a345a80d","708":"7da09c34"}[chunkId] + ".chunk.js";
};